import i18n from '@/locale/index'
const remindTime = {
  remindTypeOptions: [
    {
      value: 'REMIND_SUBMIT_FORM',
      label: i18n._t('messageRemindModal.remindType.remindSubmit', i18n.locale, i18n.messages)
    }, {
      value: 'REMIND_SAVE_FORM',
      label: i18n._t('messageRemindModal.remindType.remindSave', i18n.locale, i18n.messages)
    }, {
      value: 'REMIND_CHANGE_CODE',
      label: i18n._t('messageRemindModal.remindType.remindChangeCode', i18n.locale, i18n.messages)
    }, {
      value: 'REMIND_FORM_CODE',
      label: i18n._t('messageRemindModal.remindType.remindFormCode', i18n.locale, i18n.messages)
    }, {
      value: 'REMIND_AUTO',
      label: i18n._t('messageRemindModal.remindType.remindAuto', i18n.locale, i18n.messages)
    }
  ],
  remindTypePersonOptions: [
    {
      value: 'REMIND_APPOINT',
      label: i18n._t('messageRemindModal.remindType.remindAppoint', i18n.locale, i18n.messages)
    },
    {
      value: 'REMIND_FORM_CODE_PERSON',
      label: i18n._t('messageRemindModal.remindType.remindFormCodePerson', i18n.locale, i18n.messages)
    }
  ],
  repeatTypeOptions: [
    { value: 'ONE_TIME', label: i18n._t('messageRemindModal.remindTime.repeatType.oneTime', i18n.locale, i18n.messages) },
    { value: 'EVERY_DAY', label: i18n._t('messageRemindModal.remindTime.repeatType.everyDay', i18n.locale, i18n.messages) },
    { value: 'EVERY_WEEK', label: i18n._t('messageRemindModal.remindTime.repeatType.everyWeek', i18n.locale, i18n.messages) },
    { value: 'EVERY_MONTH', label: i18n._t('messageRemindModal.remindTime.repeatType.everyMonth', i18n.locale, i18n.messages) },
    { value: 'EVERY_QUARTER', label: i18n._t('messageRemindModal.remindTime.repeatType.everyQuarter', i18n.locale, i18n.messages) },
    { value: 'EVERY_YEAR', label: i18n._t('messageRemindModal.remindTime.repeatType.everyYear', i18n.locale, i18n.messages) },
    { value: 'EVERY_SOME_DAY', label: i18n._t('messageRemindModal.remindTime.repeatType.everySomeDay', i18n.locale, i18n.messages) }
  ],
  remindWhen: [
    {
      value: 'TODAY',
      label: i18n._t('messageRemindModal.remindTime.remindWhen.today', i18n.locale, i18n.messages)
    },
    {
      value: 'BEFORE',
      label: i18n._t('messageRemindModal.remindTime.remindWhen.before', i18n.locale, i18n.messages)
    },
    {
      value: 'AFTER',
      label: i18n._t('messageRemindModal.remindTime.remindWhen.after', i18n.locale, i18n.messages)
    }
  ],
  timeUnit: [
    {
      value: 'MIN',
      label: i18n._t('messageRemindModal.remindTime.timeUnit.min', i18n.locale, i18n.messages)
    },
    {
      value: 'DAY',
      label: i18n._t('messageRemindModal.remindTime.timeUnit.day', i18n.locale, i18n.messages)
    }
  ]
}
export default remindTime
